import React from 'react';
import ReactDOM from 'react-dom/client';
import '@localization/i18n';
import { ErrorBoundary } from '@components/ErrorBoundary';
import { SiteConfig } from '@utils';
import { Providers } from './Providers';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

(async () => {
  await SiteConfig.init();

  root.render(
    <React.StrictMode>
      <ErrorBoundary>
        <Providers>
          <App />
        </Providers>
      </ErrorBoundary>
    </React.StrictMode>,
  );
})();
